import { TbReportMoney } from "react-icons/tb";
import { formatMoney } from "../../utils/number";
import { Price } from "../Price/Price";
import { HidePrices } from "../HidePrices/HidePrices";

export function FinancialSummary({ amounts: amountsProps, ...props }) {

   const amounts = [
      {
         category: 'A receber (próx. 30 dias)',
         amount: amountsProps?.toBeReceived ?? 0,
      },
      {
         category: 'Em atraso',
         amount: amountsProps?.overdue ?? 0
      },
      {
         category: 'Recebida no período',
         amount: amountsProps?.received ?? 0
      },
      {
         category: 'Recebimentos previstos',
         amount: ((amountsProps?.received ?? 0) + (amountsProps?.toBeReceived ?? 0) + (amountsProps?.overdue ?? 0)) ?? 0
      }
   ];

   return (
      <div className="w-full h-full border! border-(--borderColor)! rounded-(--borderRadius)! **:text-(--textColor) box-border! shadow-(--box-shadow) bg-(--containerBackgroundColor)">
         <div className="flex gap-2 flex-row items-center justify-between w-full border-b! border-(--borderColor)! px-5! py-2.5! box-border! font-bold! text-[0.9rem]!">
            <div className="inline-flex flex-row items-center gap-2">
               <TbReportMoney size={21} />
               <span className="font-bold! leading-[0.1]!">Resumo financeiro</span>
            </div>
            <HidePrices className="border-transparent!" />
         </div>
         <div className="w-full px-6! py-3! box-border!">
            <table className="table-auto w-full">
               <thead>
                  <tr>
                     <th></th>
                     <th></th>
                  </tr>
               </thead>
               <tbody>
                  {amounts.map((item, index) => (
                     <tr key={index} className="group/table-row">
                        <td className="box-border! px-0! py-4.5! border-b! border-(--borderColor)! group-last/table-row:border-none!">
                           <div className="flex flex-row items-center gap-2">
                              <span>
                                 {item.category}
                              </span>
                           </div>
                        </td>
                        <td className="box-border! px-0! py-4.5! border-b! border-(--borderColor)! group-last/table-row:border-none! text-right!">
                           <Price value={item.amount} />
                        </td>
                     </tr>
                  ))}
               </tbody>
            </table>
         </div>
      </div>
   );
}